var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.isPur)?_c('Dashboard'):_vm._e(),(_vm.isPur)?_c('Workbench'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }